export default "__VITE_ASSET__DIrrc$EI__"